<div class="dropdown flex-auto">
    <select [formControl]="control" autocomplete="off"
            [ngClass]="{'input-error': control.invalid }"
            [attr.data-field]="field?.fieldUuid"
            [attr.data-typeId]="field?.config?.typeId"
            [attr.tabIndex]="0"
    >
        <option value="" *ngIf="field.config.allowNull !== false || !field.config.hasOwnProperty('allowNull')"></option>

        <option *ngFor="let optionValue of (dropdownOptions$ | async)"
                [attr.disabled]="!optionValue.isActive ? 'disabled' : null"
                [ngValue]="optionValue.uuid">

            {{ optionValue.name }}
        </option>
    </select>
</div>

<p *ngIf="lockReason$ | async as reason" class="mb-0 mt-1 text-xs text-gray">
    <ng-container *ngIf="reason === 'navbar'" i18n>Vozilo lahko dodelite samo poslovalnici, izbrani v navigaciji. Za premik v drugo tam v izbirniku preklopite na &laquo;-- VSE ENOTE --&raquo;.</ng-container>
    <ng-container *ngIf="reason === 'single'" i18n>Dostop imate samo do te poslovalnice, zato vozila ni mogoče premakniti v drugo.</ng-container>
</p>
